/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMlTrainModel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.5 2a3.5 3.5 0 0 1 2.243 6.186l2.007 6.824c.174.012.345.037.512.074l.177-.5 1.886.665-.295.835a3.5 3.5 0 1 1-4.236-.64L9.892 8.977a3.525 3.525 0 0 1-.918-.017l-1.516 3.639A3.5 3.5 0 1 1 5.5 12l.041.001 1.623-3.896A3.5 3.5 0 0 1 9.5 2zm4 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-8-3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm4-10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="m17.473 11.999-.765 2.167-1.887-.665.765-2.167zM20 4h3v2h-3v3h-1.998l.47.166-.618 1.75-.942-.333-.943-.332.383-1.084.234-.666L18 8.999V6h-3V4h3V1h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgMlTrainModel as MlTrainModel };
